import {getConfigVar} from '@cohort/shared/utils/config';
import Router from '@cohort/wallet/router/Router';
import {withLDProvider} from 'launchdarkly-react-client-sdk';

const RouterWithFlags = withLDProvider({
  clientSideID: getConfigVar(import.meta.env.COHORT_ENV, 'launchDarklyClientId'),
  options: {
    fetchGoals: false,
    sendEvents: false,
    streaming: false, // This is needed to make tests work with networkidle
  },
})(Router);

export default RouterWithFlags;
